/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DepartmentCreateRequest } from '../models/DepartmentCreateRequest';
import type { DepartmentResponse } from '../models/DepartmentResponse';
import type { DepartmentUpdateRequest } from '../models/DepartmentUpdateRequest';
import type { PaginatedResponse_DepartmentResponse_ } from '../models/PaginatedResponse_DepartmentResponse_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DepartmentService {
    /**
     * Create Department
     *     부서 생성
     *
     * 새로운 부서를 생성합니다.
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns DepartmentResponse Created
     * @throws ApiError
     */
    public static appsDepartmentViewsCreateDepartment({
        requestBody,
    }: {
        requestBody: DepartmentCreateRequest,
    }): CancelablePromise<DepartmentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/department',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Departments
     * 부서 목록 조회 및 검색
     *
     * 워크스페이스 내 부서를 페이징하여 조회합니다. 검색 키워드가 제공되면 검색을 수행합니다.
     *
     * Args:
     * workspace_id: 워크스페이스 ID (필수)
     * include_unavailable: 비활성 부서 포함 여부 (기본값: False)
     * - True인 경우 owner 또는 admin 권한 필요
     * q: 검색 키워드 (선택사항) - 부서명 검색
     * page: 페이지 번호 (기본값: 1)
     * per_page: 페이지당 항목 수 (기본값: 100)
     * @returns PaginatedResponse_DepartmentResponse_ OK
     * @throws ApiError
     */
    public static appsDepartmentViewsListDepartments({
        workspaceId,
        includeUnavailable = false,
        q,
        page = 1,
        perPage = 100,
    }: {
        workspaceId: string,
        includeUnavailable?: boolean,
        q?: string,
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse_DepartmentResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/department',
            query: {
                'workspace_id': workspaceId,
                'include_unavailable': includeUnavailable,
                'q': q,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Department
     * 부서 조회
     *
     * ID로 특정 부서를 조회합니다.
     * @returns DepartmentResponse OK
     * @throws ApiError
     */
    public static appsDepartmentViewsGetDepartment({
        departmentId,
    }: {
        departmentId: string,
    }): CancelablePromise<DepartmentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/department/{department_id}',
            path: {
                'department_id': departmentId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Update Department
     *     부서 정보 수정
     *
     * 특정 부서의 정보를 수정합니다.
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns DepartmentResponse OK
     * @throws ApiError
     */
    public static appsDepartmentViewsUpdateDepartment({
        departmentId,
        requestBody,
    }: {
        departmentId: string,
        requestBody: DepartmentUpdateRequest,
    }): CancelablePromise<DepartmentResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/department/{department_id}',
            path: {
                'department_id': departmentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Department
     *     부서 삭제
     *
     * 특정 부서를 삭제합니다. (소프트 삭제)
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns void
     * @throws ApiError
     */
    public static appsDepartmentViewsDeleteDepartment({
        departmentId,
    }: {
        departmentId: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/department/{department_id}',
            path: {
                'department_id': departmentId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
